export default {"src":"https://fishbrain.com/_next/static/media/northDakota.11364a0e.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};